module.exports = __webpack_public_path__ + "statics/img/03.17048dc5.png";